import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { TextUtil } from "@lib/titan2/dist/util/view/TextUtil";
import * as PIXI from "pixi.js";
import { SlingoLang } from "../lang/SlingoLang";
import { FontStyle } from "../style/FontStyle";
import { SlingoStyle } from "../style/SlingoStyle";
/**
 * AbstractFullHouseProperties.ts
 */
export class AbstractFullHouseProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.animationProperties.equals(other.animationProperties) &&
            TextUtil.fieldPropertiesEqual(this.title0Properties, other.title0Properties) &&
            TextUtil.fieldPropertiesEqual(this.title1Properties, other.title1Properties) &&
            this.size.equals(other.size) &&
            this.titlePosition.equals(other.titlePosition) &&
            this.mouseBlockerProperties.equals(other.mouseBlockerProperties);
    }
    setDefaultValues() {
        this.titlePosition = new PIXI.Point(1218, 640);
        this.animationProperties = new SpineProperties(SlingoStyle.FULL_HOUSE, SlingoStyle.MODULE);
        this.title0Properties = new TextFieldProperties(FontStyle.DEFAULT, null, SlingoLang.FULL_HOUSE_0, ControlConstants.CENTER, ControlConstants.CENTER);
        this.title0Properties.size = new PIXI.Point(1200, 300);
        this.title1Properties = new TextFieldProperties(FontStyle.DEFAULT, null, SlingoLang.FULL_HOUSE_1, ControlConstants.CENTER, ControlConstants.CENTER);
        this.title1Properties.size = new PIXI.Point(1200, 300);
        this.size = new PIXI.Point(2436, 1280);
    }
}
//# sourceMappingURL=AbstractFullHouseProperties.js.map